import { DecimalPipe } from '@angular/common';
import { Component, computed, effect, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { InvestmentStrategyStore } from '@zero/onboarding/domain';
import { OnboardingContainerComponent } from '@zero/onboarding/feature-onboarding/web';
import {
  ButtonComponent,
  DividerComponent,
  IconComponent,
  ListToggleComponent,
  ModalComponent,
  PillComponent,
} from '@zero/shared/ui-web-design-system';
import { ChartConfiguration } from 'chart.js';
import { commonRoutes } from 'constants/web-app-constants';
import { BaseChartDirective } from 'ng2-charts';
import { ProductInfoComponent } from '../../components/product-info/product-info.component';

@Component({
  standalone: true,
  imports: [
    OnboardingContainerComponent,
    TranslocoPipe,
    IconComponent,
    DecimalPipe,
    PillComponent,
    NgbTooltipModule,
    DividerComponent,
    ListToggleComponent,
    BaseChartDirective,
    ModalComponent,
    ButtonComponent,
  ],
  templateUrl: './investment-strategy-choice.component.html',
  styleUrls: ['./investment-strategy-choice.component.scss'],
})
export class InvestmentStrategyChoiceComponent implements OnInit, OnDestroy {
  public readonly store = inject(InvestmentStrategyStore);
  public readonly modal = inject(NgbModal);
  readonly #router = inject(Router);

  public displayFaq1 = false;
  public displayFaq2 = false;

  constructor() {
    effect(
      () =>
        this.store.saveStrategySuccess() &&
        this.#router.navigate([commonRoutes.postlogin.onboarding.investmentStrategy.success], {
          queryParams: { strategie: this.store.currentStrategy()?.name },
        }),
    );
    effect(() => this.store.deletionSuccess() && this.#router.navigate([commonRoutes.postlogin.member_home]));
  }

  async ngOnInit() {
    await this.store.loadStrategies();
    this.store.loadNotedStrategy();
  }

  ngOnDestroy() {
    this.store.clear();
  }

  public readonly datasets = computed(() => [
    {
      data: this.store.currentStrategy()?.instruments.map((instrument) => instrument.weight),
      backgroundColor: this.colors,
      borderWidth: 0,
    },
  ]);

  public readonly options: ChartConfiguration<'doughnut'>['options'] = {
    cutout: '70%',
    responsive: true,
    plugins: {
      tooltip: {
        enabled: false,
      },
    },
  };

  public readonly colors: string[] = ['#144E8C', '#248EFF', '#BDDDFF'];

  public ignore(): void {
    this.#router.navigate([commonRoutes.postlogin.member_home]);
  }

  public showDetails(product): void {
    const modalRef = this.modal.open(ProductInfoComponent, { centered: true, size: 'lg' });
    modalRef.componentInstance.product = signal(product);
  }

  public goBack = () => this.#router.navigateByUrl(commonRoutes.postlogin.onboarding.inProgress);
}

export default InvestmentStrategyChoiceComponent;
